<mat-chip *ngIf="pointsEarnedChangeIndicator?.value !== undefined && pointsEarnedChangeIndicator?.value !== null"
  class="kpi-chip-points-earned mat-standard-chip">
  {{pointsEarnedChangeIndicator?.value}}
</mat-chip>

<mat-chip *ngIf="pointsRedeemedChangeIndicator?.value !== undefined && pointsRedeemedChangeIndicator?.value !== null" 
  class="kpi-chip-points-redeemed mat-standard-chip">
  {{pointsRedeemedChangeIndicator?.value}}
</mat-chip>